"use client"

import type { Chat } from "@/types"
import { PlusCircle, MessageSquare } from "lucide-react"

interface ChatHistoryProps {
  chats: Chat[]
  currentChatId: string
  setCurrentChatId: (id: string) => void
  createNewChat: () => void
  downloadChats: () => void
}

export default function ChatHistory({ chats, currentChatId, setCurrentChatId, createNewChat, downloadChats }: ChatHistoryProps) {
  const formatTimeStamp = (timestamp: string) => {
    const date = new Date(parseInt(timestamp));

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const padZero = (num: number) => num.toString().padStart(2, '0');

    return `${padZero(month)}月${padZero(day)}日 ${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`
  }
  return (
    <div className="w-64 h-full bg-[#e6e4e3] p-4 flex flex-col rounded-r-2xl">
      <button
        onClick={createNewChat}
        className="flex items-center justify-center gap-2 w-full py-2 px-4 bg-[#d41600] text-[#ffffff] rounded-xl mb-4 hover:opacity-75 transition-colors"
      >
        <PlusCircle size={16} />
        <span>创建新的问诊</span>
      </button>

      <div className="flex-1 overflow-y-auto">
        <h2 className="text-sm font-medium text-[#6b6b6b] mb-2">Recent Chats</h2>
        <ul className="space-y-1 flex flex-col gap-2">
          {chats.map((chat) => (
            <li key={chat.id}>
              <button
                onClick={() => setCurrentChatId(chat.id)}
                className={`flex items-center w-full py-2 px-3 rounded-lg text-left ${
                  currentChatId === chat.id ? "bg-[#0038ad] text-[#ffffff] opacity-45" : "text-[#ffffff] bg-[#0038ad] opacity-80 hover:opacity-60"
                }`}
              >
                <MessageSquare size={14} className="mr-2 shrink-0" />
                <span className="truncate">{formatTimeStamp(chat.id)}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className="mt-2">
        <button
          onClick={downloadChats}
          className="flex items-center justify-center gap-2 w-full py-2 px-4 bg-[#ffcd00] text-[#ffffff] rounded-xl mb-4 hover:opacity-75 transition-colors"
        >
          <span>下载诊疗记录</span>
        </button>
      </div>
    </div>
  )
}
